module.exports = __webpack_public_path__ + "img/DTYLX_zh_ft.76b58c85.png";